import React, { useEffect } from "react";
import Header from "./Header";

/**
 * Shared chrome for the public policy pages (Privacy / Terms / SMS Policy).
 * Same visual language as Support.jsx — cream background, serif heading,
 * left-aligned long-form layout with generous spacing. Children render as
 * the prose body. Pass `eyebrow`, `title`, `effective`, `lastUpdated`.
 */
export default function PolicyLayout({ eyebrow, title, effective, lastUpdated, children, testId }) {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="min-h-screen bg-[#FBF9F6]" data-testid={testId}>
      <Header />
      <article className="max-w-3xl mx-auto px-6 py-20 md:py-28">
        <p className="text-xs tracking-[0.3em] uppercase text-[#4A5C50] mb-4">{eyebrow}</p>
        <h1 className="serif text-5xl md:text-6xl leading-[1.05] text-[#112318]">{title}</h1>
        <div className="mt-6 flex flex-wrap gap-x-6 gap-y-1 text-xs tracking-widest uppercase text-[#4A5C50]">
          {effective && <span>Effective <span className="text-[#184A30] font-semibold">{effective}</span></span>}
          {lastUpdated && <span>Last updated <span className="text-[#184A30] font-semibold">{lastUpdated}</span></span>}
        </div>
        <div className="mt-12 prose prose-stone max-w-none policy-prose">
          {children}
        </div>
        <div className="mt-16 pt-6 border-t border-[#E5E0D8] text-center text-xs text-[#4A5C50]" data-testid="policy-legal-entity">
          Zcardon is a product of <span className="font-semibold text-[#184A30]">Zeborg Water Solution Corp.</span> · 2223 Arundel Crossing Dr, Sugar Land, TX 77479
        </div>
      </article>
      <style>{`
        .policy-prose h2 { font-family: 'Cormorant Garamond', serif; font-size: 28px; font-weight: 500; color:#112318; margin: 36px 0 10px; letter-spacing: -0.3px; }
        .policy-prose h3 { font-size: 14px; font-weight: 700; color:#184A30; letter-spacing: 0.05em; margin: 22px 0 8px; text-transform: uppercase; }
        .policy-prose p, .policy-prose li { color:#4A5C50; line-height: 1.7; font-size: 15px; }
        .policy-prose ul { list-style: disc; padding-left: 22px; margin: 8px 0 12px; }
        .policy-prose a { color:#184A30; text-decoration: underline; text-decoration-style: dotted; text-underline-offset: 3px; }
        .policy-prose a:hover { color:#0d3320; }
        .policy-prose code { background:#F4F0EA; padding: 2px 6px; border-radius: 4px; font-size: 13px; }
        .policy-prose strong { color:#112318; }
      `}</style>
    </div>
  );
}
